
                import "css-modules://src_components_inputnumber"
                export default {"Main":"_3ac065","Input":"_3609d4"}
            